import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8F7BE0',
    },
    secondary: {
      main: '#00A5C4',
    },
    background: {
      // default is what MUI's CssBaseline paints on the <body>. Using the brand
      // dark here ensures the mobile overscroll area (iOS rubber-band) also
      // shows the brand color instead of a slightly different MUI default.
      default: '#1a1a1e',
      main: '#222226',
    },
    text: {
      main: '#ECE2DB',
      secondary: '#222226',
    },
    table: {
      rows: '#00A5C430',
      rows2: '#8F7BE020',
    },
  },
  typography: {
    fontFamily: "'Urbanist', sans-serif",
    letterSpacing: '0.02em',
    h1: { fontWeight: 600, letterSpacing: '0.02em' },
    h2: { fontWeight: 600, letterSpacing: '0.02em' },
    h3: { fontWeight: 600, letterSpacing: '0.02em' },
    h4: { fontWeight: 600, letterSpacing: '0.02em' },
    h5: { fontWeight: 600, letterSpacing: '0.02em' },
    h6: { fontWeight: 600, letterSpacing: '0.02em' },
    subtitle1: { letterSpacing: '0.02em' },
    subtitle2: { letterSpacing: '0.02em' },
    body1: { fontWeight: 300, letterSpacing: '0.02em' },
    body2: { fontWeight: 300, letterSpacing: '0.02em' },
    button: { letterSpacing: '0.02em' },
    caption: { letterSpacing: '0.02em' },
    overline: { letterSpacing: '0.02em' },
  },
});

export default theme;